import ajax from "@/lib/ajax"
	;
// GetCompStatistics
// 并发症统计
export async function GetCompStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetCompStatistics', {params:payload})
	return res.data.result
}
// GetDlyOvertimeStatistics
// 加班统计
export async function GetDlyOvertimeStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetDlyOvertimeStatistics', {params:payload})
	return res.data.result
}
// GetDlyFrequencyStatistics
// 透析频次
export async function GetDlyFrequencyStatistics(){
	let res = await ajax.get('/api/services/app/Report/GetDlyFrequencyStatistics')
	return res.data.result
}
// GetPatAddStatistics
// 新增患者统计
export async function GetPatAddStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetPatAddStatistics', {params:payload})
	return res.data.result
}
// GetDisinfectStatistics
// 消毒记录
export async function GetDisinfectStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetDisinfectStatistics', {params:payload})
	return res.data.result
}
// GetPatientAgeStatistics
// 患者信息(年龄段统计)
export async function GetPatientAgeStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetPatientAgeStatistics', {params:payload})
	return res.data.result
}
// GetPatientSexStatistics
// 患者信息(性别统计)
export async function GetPatientSexStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetPatientSexStatistics', {params:payload})
	return res.data.result
}
// GetPatientOutStatistics
// 患者转归
export async function GetPatientOutStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetPatientOutStatistics', {params:payload})
	return res.data.result
}
// GetUserStatistics
// 透析室信息（人员信息）
export async function GetUserStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetUserStatistics', {params:payload})
	return res.data.result
}
// GetMachineStatistics
// 透析室信息（设备信息）
export async function GetMachineStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetMachineStatistics', {params:payload})
	return res.data.result
}
// GetMachineRepairStatistics
// 设备维修统计
export async function GetMachineRepairStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetMachineRepairStatistics', {params:payload})
	return res.data.result
}
// GetMachineMaintainStatistics
// 设备保养统计
export async function GetMachineMaintainStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetMachineMaintainStatistics', {params:payload})
	return res.data.result
}
// GetBloodStatistics
// 血压统计
export async function GetBloodStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetBloodStatistics', {params:payload})
	return res.data.result
}
// GetDlyYearStatistics
// 【透析历次】年度统计
export async function GetDlyYearStatistics(){
	let res = await ajax.get('/api/services/app/Report/GetDlyYearStatistics')
	return res.data.result
}
// GetDlyMonthCountStatistics
// 【透析历次】月份统计
export async function GetDlyMonthCountStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetDlyMonthCountStatistics', {params:payload})
	return res.data.result
}
// GetDlyDayCountStatistics
// 【透析历次】天统计
export async function GetDlyDayCountStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetDlyDayCountStatistics', {params:payload})
	return res.data.result
}
// GetVaYearStatistics
// 【通路统计】年份统计
export async function GetVaYearStatistics(){
	let res = await ajax.get('/api/services/app/Report/GetVaYearStatistics')
	return res.data.result
}
// GetVaMonthStatistics
// 【通路统计】月份统计
export async function GetVaMonthStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetVaMonthStatistics', {params:payload})
	return res.data.result
}
// GetBfvStatistics
// 血流量
export async function GetBfvStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetBfvStatistics', {params:payload})
	return res.data.result
}
// GetBfvStatistics
// 原发病统计
export async function GetDlyChargeStatistics(payload: any){
	let res = await ajax.post('/api/services/app/Report/GetDlyChargeStatistics', payload)
	return res.data.result
}
// GetVaComplStatistics
// 细菌内毒素
export async function GetVaComplStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetVaComplStatistics', {params:payload})
	return res.data.result
}
// GetWaterMachineCheckStatistics
// 水处理检查
export async function GetWaterMachineCheckStatistics(payload: any){
	let res = await ajax.post('/api/services/app/Report/GetWaterMachineCheckStatistics', payload)
	return res.data.result
}
// GetAbnormityStatistics
// 异常下机
export async function GetAbnormityStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetAbnormityStatistics', {params:payload})
	return res.data.result
}
// GetVaInfectionStatistics
// 通路感染
export async function GetVaInfectionStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetVaInfectionStatistics', {params:payload})
	return res.data.result
}
// GetWaterMachine
// 查询 细菌内毒素
export async function GetWaterMachine(){
	let res = await ajax.get('/api/services/app/Report/GetWaterMachine')
	return res.data.result
}

// GetCommonAssayStatistics
// 常用化验项
export async function GetCommonAssayStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetCommonAssayStatistics',{params:payload})
	return res.data.result
}
// GetAssayStatistics
// 化验项
export async function GetAssayStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetAssayStatistics',{params:payload})
	return res.data.result
}
// GetBorrowMedStatistics
// 借药统计
export async function GetBorrowMedStatistics(payload: any){
	let res = await ajax.get('/api/services/app/Report/GetBorrowMedStatistics',{params:payload})
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/report/index.ts